module.exports = __webpack_public_path__ + "img/warningBg.bcd74cba.png";